import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";

const PabrikLD = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });
  const [detailData, setDetailData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Helper konversi waktu UTC/GMT ke WIB (GMT+7)
  const formatToWIB = (dateString, withTime = false) => {
    if (!dateString || dateString === "-") return "-";

    let isoString = String(dateString).trim();
    if (!isoString.endsWith("Z") && !isoString.includes("+")) {
      isoString = isoString.replace(" ", "T") + "Z";
    }

    const date = new Date(isoString);
    if (isNaN(date.getTime())) return dateString;

    const options = {
      timeZone: "Asia/Jakarta",
      day: "numeric",
      month: "short",
      year: "numeric",
      ...(withTime && {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }),
    };

    return (
      new Intl.DateTimeFormat("id-ID", options).format(date) +
      (withTime ? " WIB" : "")
    );
  };

  const formatRupiah = (num) => {
    if (num === null || num === undefined || isNaN(Number(num))) return "-";
    return "Rp " + Number(num).toLocaleString("id-ID");
  };

  const formatNumber = (num) => {
    if (num === null || num === undefined || isNaN(Number(num))) return "-";
    return Number(num).toLocaleString("id-ID");
  };

  const handleBack = () => {
    navigate("/pabrikt");
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
    } catch (err) {
      console.warn("Logout warning:", err);
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  };

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    // Ambil info pengguna
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const resData = response.data;
        if (!resData.error) {
          setUserInfo({
            role: resData.role,
            name: resData.name,
            full_name: resData.full_name,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching user info:", err);
      });

    // Ambil detail riwayat dari endpoint yang sama dengan logistik
    const fetchDetailPengiriman = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://c-greenproject.org:7500/detail_pengiriman_logistik?tracking_id=${id}`,
          { withCredentials: true }
        );

        if (response.data && response.data.detail) {
          setDetailData(response.data.detail);
        } else {
          setError("Rincian data pengiriman tidak ditemukan.");
        }
      } catch (err) {
        console.error("Error fetching detail:", err);
        setError("Gagal memuat rincian data pengiriman dari server.");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchDetailPengiriman();
    }
  }, [id]);

  const getStatusBadge = (status) => {
    const s = String(status || "").toLowerCase().trim();
    if (s.includes("selesai") || s.includes("terkirim") || s.includes("diterima") || s.includes("approved")) {
      return <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-1.5 rounded-pill fw-semibold text-capitalize">{status}</span>;
    }
    if (s.includes("jalan") || s.includes("pengiriman") || s.includes("transit")) {
      return <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-1.5 rounded-pill fw-semibold text-capitalize">{status}</span>;
    }
    if (s.includes("batal") || s.includes("gagal") || s.includes("reject")) {
      return <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-1.5 rounded-pill fw-semibold text-capitalize">{status}</span>;
    }
    return <span className="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle px-3 py-1.5 rounded-pill fw-semibold text-capitalize">{status || "Pending"}</span>;
  };

  const timbangan = detailData?.timbangan || {};
  const asalPetani = detailData?.asal_petani || {};
  const tujuanPabrik = detailData?.tujuan_pabrik || {};
  const driverList = detailData?.armada_driver || [];

  return (
    <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: "#f8fafc" }}>
      {/* Header */}
      <div className="header bg-white border-bottom shadow-sm">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span>{userInfo.full_name} |</span>
          <button
            className="btn btn-outline-success btn-sm rounded-pill px-3"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1" style={{ width: "100%", overflowX: "hidden" }}>
        {/* Sidebar */}
        <div className="sidebar p-3" style={{ width: "240px", flexShrink: 0 }}>
          <p>Portal Sistem Traceability</p>
          <h6>Telsa Super Apps</h6>
          <p>
            <img src="/static/schedule_11145854.png" alt="Date" />
            {tanggal}
          </p>
          <div className="list-group list-group-flush">
            <div
              onClick={() => navigate("/pabrik")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/pabrik" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/pabrik" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/pabrikt")}
              className={`list-group-item text-decoration-none ${
                location.pathname.includes("/pabrikt") || location.pathname.includes("/pabrikld")
                  ? "active text-white"
                  : ""
              }`}
              style={{
                color:
                  location.pathname.includes("/pabrikt") || location.pathname.includes("/pabrikld")
                    ? "white"
                    : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/shipping.png" alt="Transactions" /> Transaksi
            </div>
            <div
              onClick={() => navigate("/pabrikh")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/pabrikh" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/pabrikh" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/packaging.png" alt="Results" /> Hasil
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div
          className="flex-grow-1 p-4"
          style={{
            width: "calc(100% - 240px)",
            minWidth: 0,
            overflowX: "hidden",
          }}
        >
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
            <div>
              <h2 className="fw-bold text-dark mb-1">
                Rincian Transaksi Pengiriman
              </h2>
              <p className="text-muted small mb-0">
                Informasi lengkap rantai pasok dan armada pengiriman sawit ke pabrik.
              </p>
            </div>
            <button
              className="btn btn-outline-success rounded-pill px-4 shadow-sm fw-semibold"
              onClick={handleBack}
            >
              <i className="fa fa-arrow-left me-2"></i>Kembali
            </button>
          </div>

          <div className="divider mb-4"></div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="text-muted mt-2">Memuat rincian data pengiriman...</p>
            </div>
          ) : error ? (
            <div className="alert alert-danger rounded-4 shadow-sm" role="alert">
              <i className="fa fa-exclamation-triangle me-2"></i> {error}
            </div>
          ) : (
            <div className="bg-white rounded-4 border shadow-sm p-4">
              {/* Header Status Ringkas */}
              <div className="d-flex flex-wrap justify-content-between align-items-center pb-3 mb-4 border-bottom gap-2">
                <div>
                  <span className="text-muted small d-block">TRACKING ID</span>
                  <h4 className="fw-bold font-monospace text-success m-0">
                    #{detailData?.tracking_id || "-"}
                  </h4>
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <span className="text-muted small">Status Logistik:</span>
                  {getStatusBadge(detailData?.status_logistik)}
                  <span className="text-muted small ms-2">Status Kirim:</span>
                  {getStatusBadge(detailData?.status_pengiriman)}
                </div>
              </div>

              {/* Parameter Timbangan & Biaya */}
              <div className="bg-light p-4 rounded-4 border mb-4">
                <h6 className="fw-bold text-success mb-3">
                  ⚖️ Parameter Timbangan & Pembayaran
                </h6>
                <div className="row g-3">
                  <div className="col-6 col-md-3">
                    <small className="text-muted d-block">JENIS SAWIT</small>
                    <strong className="text-dark fs-6">{timbangan.jenis_sawit || "-"}</strong>
                  </div>
                  <div className="col-6 col-md-3">
                    <small className="text-muted d-block">BERAT AWAL</small>
                    <strong className="text-dark fs-6">
                      {timbangan.berat_awal ? `${formatNumber(timbangan.berat_awal)} Kg` : "-"}
                    </strong>
                  </div>
                  <div className="col-6 col-md-3">
                    <small className="text-muted d-block">BERAT AKHIR (PABRIK)</small>
                    <strong className="text-success fs-6">
                      {timbangan.berat_akhir ? `${formatNumber(timbangan.berat_akhir)} Kg` : "-"}
                    </strong>
                  </div>
                  <div className="col-6 col-md-3">
                    <small className="text-muted d-block">TOTAL BIAYA</small>
                    <strong className="text-primary fs-6">
                      {formatRupiah(timbangan.total_biaya)}
                    </strong>
                  </div>
                  <div className="col-6 col-md-3">
                    <small className="text-muted d-block">SELISIH BERAT</small>
                    <span className="fw-semibold text-secondary">
                      {timbangan.selisih !== undefined ? `${formatNumber(timbangan.selisih)} Kg` : "-"}
                    </span>
                  </div>
                  <div className="col-6 col-md-3">
                    <small className="text-muted d-block">TANGGAL PENGIRIMAN</small>
                    <span className="text-dark">
                      {formatToWIB(detailData?.tanggal_pengiriman)}
                    </span>
                  </div>
                  <div className="col-6 col-md-3">
                    <small className="text-muted d-block">TANGGAL DITERIMA</small>
                    <span className="text-dark">
                      {formatToWIB(detailData?.tanggal_diterima)}
                    </span>
                  </div>
                </div>
              </div>

              {/* Rincian Asal & Tujuan */}
              <div className="row g-3 mb-4">
                <div className="col-md-6">
                  <div className="p-4 rounded-4 border bg-light h-100">
                    <h6 className="fw-bold text-success mb-3">📍 Asal Penjemputan (Petani)</h6>
                    <div className="mb-2">
                      <small className="text-muted d-block">Nama Petani</small>
                      <strong className="text-dark">{asalPetani.nama || "-"}</strong>
                    </div>
                    <div className="mb-2">
                      <small className="text-muted d-block">Kontak HP</small>
                      <span className="text-primary font-monospace">📞 {asalPetani.nomor_hp || "-"}</span>
                    </div>
                    <div>
                      <small className="text-muted d-block">Alamat Jemput / Lahan</small>
                      <span className="text-secondary small">{asalPetani.alamat_jemput || "-"}</span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="p-4 rounded-4 border bg-light h-100">
                    <h6 className="fw-bold text-primary mb-3">🏭 Tujuan Pengantaran (Pabrik)</h6>
                    <div className="mb-2">
                      <small className="text-muted d-block">Nama Pabrik</small>
                      <strong className="text-dark">{tujuanPabrik.nama || "-"}</strong>
                    </div>
                    <div className="mb-2">
                      <small className="text-muted d-block">Kontak Pabrik</small>
                      <span className="text-primary font-monospace">📞 {tujuanPabrik.nomor_hp || "-"}</span>
                    </div>
                    <div>
                      <small className="text-muted d-block">Alamat Pabrik</small>
                      <span className="text-secondary small">{tujuanPabrik.alamat || "-"}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Tabel Driver & Armada */}
              <div className="p-4 rounded-4 border bg-light">
                <h6 className="fw-bold text-secondary mb-3">🚚 Data Driver & Posisi Armada</h6>
                {driverList.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0 bg-white rounded-3 overflow-hidden shadow-sm">
                      <thead className="table-light">
                        <tr className="small text-secondary">
                          <th>Driver</th>
                          <th>Plat Truk</th>
                          <th>Status</th>
                          <th>Lokasi Terakhir</th>
                          <th>Waktu Update</th>
                        </tr>
                      </thead>
                      <tbody>
                        {driverList.map((drv, idx) => (
                          <tr key={`driver-row-${idx}`}>
                            <td><strong>{drv.nama_driver || "-"}</strong></td>
                            <td className="font-monospace">{drv.plat_truk || "-"}</td>
                            <td>
                              <span className="badge bg-primary-subtle text-primary border px-2.5 py-1">
                                {drv.status || "-"}
                              </span>
                            </td>
                            <td>{drv.lokasi || "-"}</td>
                            <td className="text-muted small">
                              {formatToWIB(drv.waktu_update, true)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-muted fst-italic small m-0">
                    Belum ada data driver/armada yang ditugaskan.
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PabrikLD;